export const MESSAGE_SKELETONS = [
	{ alignRight: false, width: '58%', height: '44px' },
	{ alignRight: true, width: '52%', height: '36px' },
	{ alignRight: false, width: '64%', height: '52px' },
	{ alignRight: true, width: '48%', height: '36px' },
	{ alignRight: false, width: '56%', height: '40px' },
];
